import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { EmptyStatePlaceholder, StyledMaxWidth } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';
import { MedicalTreatmentConsentPanel } from '../MedicalTreatmentConsentPanel';

import { MedicalTreatmentConsentEnterAction } from './MedicalDataAccessConsentEnterAction/MedicalTreatmentConsentEnterAction';

export type MedicalTreatmentConsentEnterPanelProps = {
   readonly patientId: Patient['id'];
   readonly withdrawDate?: Date;
};

const MedicalTreatmentConsentEnterPanel = (props: MedicalTreatmentConsentEnterPanelProps): JSX.Element => {
   if (props.withdrawDate) {
      return (
         <MedicalTreatmentConsentPanel
            labelKey={patientConsentsAndAuthorizationsTranslationKeys.consent.consentWithdrawn}
            date={props.withdrawDate}
            testId={'medicalTreatmentConsentWithdrawnLabel'}
         >
            <MedicalTreatmentConsentEnterAction patientId={props.patientId} />
         </MedicalTreatmentConsentPanel>
      );
   }

   return (
      <StyledMaxWidth maxWidth={480}>
         <EmptyStatePlaceholder
            heading={patientConsentsAndAuthorizationsTranslationKeys.consent.noInfo}
            subheading={
               patientConsentsAndAuthorizationsTranslationKeys.consent
                  .doesPatientConsentToProvisionMedicalServicesAndProcessingPersonalData
            }
            fullLength
            testId={'noInfo'}
         >
            <MedicalTreatmentConsentEnterAction patientId={props.patientId} />
         </EmptyStatePlaceholder>
      </StyledMaxWidth>
   );
};

export { MedicalTreatmentConsentEnterPanel };
